import { Injectable } from '@angular/core';
import { Notification, UtilService, ApiService } from '../shared/index';
import { IListingSubCategorySearchService } from './ilisting-sub-category-search.service';
import { ListingSubCategorySearchParams } from './listing-sub-category-search-params.model';
import { ListingSubCategory } from './listing-sub-category.model';
import { ListingSubCategorySearchResult } from './listing-sub-category-search-result.model';
import { PagedResult } from '../shared/model/generic-paged-result.model';

@Injectable({
  providedIn: 'root',
})
export class ListingSubCategoryService implements IListingSubCategorySearchService {
  public _utilService: UtilService;
  public _apiService: ApiService;

  public constructor(utilService: UtilService, apiService: ApiService) {
    this._utilService = utilService;
    this._apiService = apiService;
  }

  public search(params: ListingSubCategorySearchParams): Promise<ListingSubCategorySearchResult> {
    let url: string = '/ListingSubCategories';
    return this._apiService.getPaged(url, params);
  }

  public get(id: number): Promise<ListingSubCategory> {
    return this._apiService.get(`ListingSubCategory/${id}`);
  }

  public create(dto: ListingSubCategory): Promise<number> {
    return this._apiService.post('ListingSubCategories', dto);
  }

  public update(dto: ListingSubCategory): Promise<void> {
    return this._apiService.put(`ListingSubCategory/${dto.SubCategoryID}`, dto);
  }

  public delete(id: number): Promise<void> {
    return this._apiService.delete(`ListingSubCategory/${id}`);
  }

  public getSubCategoriesForCategoryId(categoryId: number): Promise<PagedResult<ListingSubCategory[]>> {
    return this._apiService.getPaged('/ListingSubCategories', {
      CategoryId: categoryId,
      PageNumber: 0,
      PageSize: 0,
      OrderBy: 'SubCategory',
    });
  }

  public getCategoriesAndSubCategoriesForProfileSelector(): Promise<any> {
    return this._apiService.get('/ListingSubCategories/ForProfileSelector');
  }
}
